import { Divider } from 'antd';
import React, { FC } from 'react';
import { Trans } from 'next-i18next';
import styled from 'styled-components';

interface CCPOMainContentTitleV2Props {
  isTextWhite?: boolean;
  textNumber: string;
  textTitle: string;
}
const StyledWrapper = styled.div<{ isTextWhite?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;

  .number-one {
    font-family: 'Poppins';
    font-size: 25px;
    line-height: 30px;
    color: ${(props) => props.theme.color.primaryBase};
    font-weight: 300;
  }

  .divider {
    height: 40px;
    color: ${(props) => (props.isTextWhite ? '#fff' : '#000')};
    border-left: 2px solid ${(props) => (props.isTextWhite ? '#fff' : '#000')};
    margin: 0 16px;
  }

  .text-title {
    ${(props) => props.theme.typo.familyGoogle.bold}
    font-size: 15px;
    line-height: 20px;
    color: ${(props) => (props.isTextWhite ? '#fff' : '#000')};
  }

  @media screen and (min-width: 1184px) {
    .number-one {
      font-size: 35px;
    }

    .divider {
      height: 60px;
    }

    .text-title {
      font-size: 24px;
      line-height: 30px;
    }
  }
`;

const CCPOMainContentTitleV2: FC<CCPOMainContentTitleV2Props> = ({ isTextWhite, textNumber, textTitle }) => (
  <StyledWrapper isTextWhite={isTextWhite}>
    <span className="number-one">{textNumber}</span>
    <Divider className="divider" type="vertical" />
    <span className="text-title">
      <Trans
        ns="ccpo"
        defaults={textTitle || ''}
        components={{ br: <br />, specificFont: <span style={{ fontFamily: 'Poppins' }} /> }}
      />
    </span>
  </StyledWrapper>
);

export default CCPOMainContentTitleV2;
